import "../../styles/Users.css";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import {useState, useEffect} from "react";
import {useCookies} from "react-cookie";
import { Navigate, useNavigate } from "react-router-dom";

export default function Users({dark, setDark, sidebarOpen, setSidebarOpen}) {

    const navigate = useNavigate();
    const [openAddUser, setOpenAddUser] = useState(false);
    const [closingDrawer, setClosingDrawer] = useState(false);
    const [users, setUsers] = useState([])
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [editUser, setEditUser] = useState(null); // utilisateur en cours d’édition
    const [openEditDrawer, setOpenEditDrawer] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(null); // id de l’utilisateur à supprimer
    const [closingConfirm, setClosingConfirm] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 12; // nombre d’entrées par page
    const [search, setSearch] = useState("");
    const [toastProgress, setToastProgress] = useState(100);
    const [openMessageDrawer, setOpenMessageDrawer] = useState(false);
    const [messageTarget, setMessageTarget] = useState(null);
    const [messageText, setMessageText] = useState("");
    const [sendingMessage, setSendingMessage] = useState(false);

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);



    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://api.industriegaming.fr/api/auth/getall", {
                    headers: {
                        'Authorization': `Bearer ${cookies.token}`,
                    }
                });
                if (response.status === 403) {
                    return <Navigate to="/" replace />;
                }
                if (response.status === 401) {
                    removeCookie("token", { path: "/" });
                    navigate("/");
                    return;
                }
                const data = await response.json();

                // Normalisation des données pour éviter les erreurs toLowerCase()
                const safeUsers = data.map(u => ({
                    id: u.id,
                    name: u.name,
                    email: u.email,
                    role: u.role || "Utilisateur",
                    status: u.status || "Actif"
                }));

                setUsers(safeUsers);
            } catch (error) {
                console.error("Erreur lors du chargement des utilisateurs :", error);
            }
        };

        fetchUsers();
    }, []);

    const filteredUsers = users.filter((user) =>
        user.name.toLowerCase().includes(search.toLowerCase()) ||
        user.email.toLowerCase().includes(search.toLowerCase()) ||
        user.role.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);

    const indexOfLastUser = currentPage * entriesPerPage;
    const indexOfFirstUser = indexOfLastUser - entriesPerPage;
    // const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    const emptyRows = entriesPerPage - currentUsers.length;

    // const totalPages = Math.ceil(users.length / entriesPerPage);

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);


    const getPaginationButtons = () => {
        const pages = [];
        const maxPagesToShow = 5;

        if (totalPages <= maxPagesToShow) {
            // Si peu de pages → on les affiche toutes
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            // Toujours afficher la première page
            pages.push(1);

            // Ajouter "..." si on est loin du début
            if (currentPage > 3) pages.push("...");

            // Pages autour de la page actuelle
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);

            for (let i = start; i <= end; i++) pages.push(i);

            // Ajouter "..." si on est loin de la fin
            if (currentPage < totalPages - 2) pages.push("...");

            // Toujours afficher la dernière page
            pages.push(totalPages);
        }

        return pages;
    };


    const closeConfirm = () => {
        setClosingConfirm(true);
        setTimeout(() => {
            setDeleteConfirm(null);
            setClosingConfirm(false);
        }, 200); // doit matcher la durée de popupOut
    };



    const toggleTheme = () => setDark(!dark);

    const closeDrawer = () => {
        setClosingDrawer(true);
        setTimeout(() => {
            setOpenAddUser(false);
            setOpenEditDrawer(false)
            setClosingDrawer(false);
        }, 250); // durée de l’animation
    };

    const [newUser, setNewUser] = useState({
        name: "",
        email: "",
        password: "",
        role: "Utilisateur",
        status: "Actif"
    });

    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const deleteUser = async () => {
        try {
            const response = await fetch(`https://api.industriegaming.fr/api/auth/delete/${deleteConfirm}`, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${cookies.token}`
                }
            });
            if (response.status === 403) {
                return <Navigate to="/" replace />;
            }

            if (!response.ok) throw new Error("Erreur API");

            setUsers(users.filter(u => u.id !== deleteConfirm));
            setSuccessMessage("Utilisateur supprimé !");
        } catch (error) {
            console.error(error);
            setErrorMessage("Impossible de supprimer l'utilisateur.");
        }

        setClosingConfirm(true);
        setTimeout(() => {
            setDeleteConfirm(null);
            setClosingConfirm(false);
        }, 200); // durée = même que l’animation CSS

    };

    const updateUser = async () => {
        if (!editUser.name.trim() || !editUser.email.trim()) {
            setErrorMessage("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        try {
            const response = await fetch(`https://api.industriegaming.fr/api/auth/edit/${editUser.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${cookies.token}`
                },
                body: JSON.stringify(editUser)
            });

            if (response.status === 403) {
                return <Navigate to="/" replace />;
            }

            if (!response.ok) throw new Error("Erreur API");

            // Mise à jour locale
            setUsers(users.map(u => (u.id === editUser.id ? editUser : u)));

            setSuccessMessage("Utilisateur mis à jour !");
            closeDrawer();
        } catch (error) {
            console.error(error);
            setErrorMessage("Impossible de mettre à jour l'utilisateur.");
        }
    };


    const saveUser = async () => {
        // Validation simple
        if (!newUser.name.trim() || !newUser.email.trim() || !newUser.password.trim()) {
            setErrorMessage("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        // Vérification email
        if (!isValidEmail(newUser.email)) {
            setErrorMessage("Adresse email invalide.");
            return;
        }

        try {
            // --- Envoi API ---
            const response = await fetch("https://api.industriegaming.fr/api/auth/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${cookies.token}`
                },
                body: JSON.stringify(newUser)
            });

            if (response.status === 403) {
                return <Navigate to="/" replace />;
            }

            if (!response.ok) {
                throw new Error("Erreur API");
            }

            const createdUser = await response.json();

            // --- Ajout dans la table locale ---
            setUsers([...users, {
                id: Date.now(),
                ...newUser
            }]);

            // --- Message succès ---
            setSuccessMessage("Utilisateur ajouté avec succès !");
        } catch (error) {
            console.error("Erreur API :", error);

            // Fallback si l’API échoue → on ajoute quand même localement
            setUsers([
                ...users,
                {
                    id: Date.now(),
                    ...newUser
                }
            ]);

            setSuccessMessage("Utilisateur ajouté (mode hors-ligne).");
        }

        // Reset du formulaire
        setNewUser({
            name: "",
            email: "",
            password: "",
            role: "Utilisateur",
            status: "Actif"
        });

        // Fermeture animée du drawer
        closeDrawer();
    };

    useEffect(() => {
        if (successMessage) {
            // const timer = setTimeout(() => setSuccessMessage(""), 2500);
            // return () => clearTimeout(timer);
            setToastProgress(100);

            let width = 100;
            const interval = setInterval(() => {
                width -= 1;
                setToastProgress(width);

                if (width <= 0) {
                    clearInterval(interval);
                    setSuccessMessage("");
                }
            }, 25);
        }
    }, [successMessage]);

    useEffect(() => {
        if (errorMessage) {
            // const timer = setTimeout(() => setErrorMessage(""), 2500);
            setToastProgress(100);
            let width = 100;
            const interval = setInterval(() => {
                width -= 1;
                setToastProgress(width);

                if (width <= 0) {
                    clearInterval(interval);
                    setErrorMessage("");
                }
            }, 25); // 100 * 30ms = 3 secondes
            // return () => clearTimeout(timer);
        }
    }, [errorMessage]);

    const closeMessageDrawer = () => {
        setOpenMessageDrawer(false);
        setTimeout(() => {
            setMessageTarget(null);
            setMessageText("");
            setSendingMessage(false);
        }, 200);
    };

    const sendMessage = async () => {
        if (!messageText.trim()) {
            setErrorMessage("Le message est vide.");
            return;
        }

        setSendingMessage(true);

        try {
            const body = {
                text: messageText,
                type: "user",
                userId: messageTarget.id
            };

            const res = await fetch("https://api.industriegaming.fr/api/auth/notification", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${cookies.token}`
                },
                body: JSON.stringify(body)
            });

            if (res.status === 401) {
                removeCookie("token", { path: "/" });
                navigate("/");
                return;
            }

            if (!res.ok) throw new Error("Erreur API");

            setSuccessMessage("Message envoyé !");
            closeMessageDrawer();
        } catch (err) {
            console.error(err);
            setErrorMessage("Impossible d'envoyer le message.");
            setSendingMessage(false);
        }
    };




    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            {/* Sidebar */}
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Contenu principal */}
            <div className="main">
                {/* Topbar */}
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                {/* Page Utilisateurs */}
                <div className="users-page">
                    <div className="users-header">
                        <div className="users-header-logo">
                            <h1>Utilisateurs</h1>
                            <div className="users-search">
                                <input
                                    type="text"
                                    placeholder="Rechercher un utilisateur..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>

                        {user?.role === "Admin" && (
                            <button className="add-user-btn" onClick={() => setOpenAddUser(true)}>
                                + Ajouter un utilisateur
                            </button>
                        )}
                    </div>

                    <div className="users-table-wrapper">
                        <table className="users-table">
                            <thead>
                            <tr>
                            <th>Nom</th>
                                <th>Email</th>
                                <th>Rôle</th>
                                <th>Statut</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {currentUsers.map((u) => (
                                <tr key={u.id}>
                                    <td>{u.name}</td>
                                    <td>{u.email}</td>
                                    <td>
                      <span className={`role-badge ${u.role.toLowerCase()}`}>
                        {u.role}
                      </span>
                                    </td>
                                    <td>
                      <span className={`status-badge ${u.status.toLowerCase()}`}>
                        {u.status}
                      </span>
                                    </td>
                                    <td className="actions">
                                        <button
                                            className="view-btn"
                                            onClick={() => navigate(`/profile/${u.id}`)}
                                        >
                                            👁️
                                        </button>

                                        <button
                                            className="message-btn"
                                            title={`Envoyer un message à ${u.name}`}
                                            onClick={() => {
                                                setMessageTarget(u);
                                                setMessageText("");
                                                setOpenMessageDrawer(true);
                                            }}
                                        >
                                            ✉️
                                        </button>

                                        {user?.role === "Admin" && (
                                            <button
                                                className="edit-btn"
                                                onClick={() => {
                                                    setEditUser(u);
                                                    setOpenEditDrawer(true);
                                                }}
                                            >
                                                ✏️
                                            </button>
                                        )}
                                        {user?.role === "Admin" && (
                                            <button
                                                className="delete-btn"
                                                onClick={() => setDeleteConfirm(u.id)}
                                            >
                                                🗑️
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {Array.from({ length: emptyRows }).map((_, i) => (
                                <tr key={`empty-${i}`} className="empty-row">
                                    <td colSpan="5"></td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>

                            {getPaginationButtons().map((page, index) => (
                                page === "..." ? (
                                    <span key={index} className="dots">...</span>
                                ) : (
                                    <button
                                        key={index}
                                        className={currentPage === page ? "active" : ""}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </button>
                                )
                            ))}

                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                <i className="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>


                        {openAddUser && (
                            <div className={`drawer-overlay ${closingDrawer ? "closing" : ""}`} onClick={closeDrawer}>
                                <div
                                    className={`drawer ${closingDrawer ? "closing" : ""}`}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <h2>Ajouter un utilisateur</h2>

                                    <label>Nom</label>
                                    <input
                                        type="text"
                                        placeholder="Nom complet"
                                        value={newUser.name}
                                        onChange={(e) => setNewUser({...newUser, name: e.target.value})}
                                    />

                                    <label>Email</label>
                                    <input
                                        type="email"
                                        placeholder="Adresse email"
                                        value={newUser.email}
                                        onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                                    />

                                    <label>Mot de passe</label>
                                    <input
                                        type="text"
                                        placeholder="Mot de passe"
                                        value={newUser.password}
                                        onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                                    />


                                    <label>Rôle</label>
                                    <select
                                        value={newUser.role}
                                        onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                                    >
                                        <option>Utilisateur</option>
                                        <option>Moderateur</option>
                                        <option>Admin</option>
                                    </select>

                                    <label>Statut</label>
                                    <select
                                        value={newUser.status}
                                        onChange={(e) => setNewUser({...newUser, status: e.target.value})}
                                    >
                                        <option>Actif</option>
                                        <option>Suspendu</option>
                                    </select>

                                    <button className="save-user-btn" onClick={saveUser}>
                                        Enregistrer
                                    </button>
                                </div>
                            </div>
                        )}
                        {openMessageDrawer && (
                            <div className={`drawer-overlay ${closingDrawer ? "closing" : ""}`} onClick={closeMessageDrawer}>
                                <div
                                    className={`drawer ${closingDrawer ? "closing" : ""}`}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <h2>Envoyer un message à {messageTarget?.name}</h2>

                                    <label>Message</label>
                                    <textarea
                                        rows={6}
                                        placeholder={`Écrire un message à ${messageTarget?.name}...`}
                                        value={messageText}
                                        onChange={(e) => setMessageText(e.target.value)}
                                        style={{resize: 'vertical', padding: 10, borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--card-bg)', color: 'var(--text-color)'}}
                                    />

                                        <button className="save-user-btn" onClick={sendMessage} disabled={sendingMessage}>
                                            {sendingMessage ? 'Envoi...' : 'Envoyer'}
                                        </button>
                                </div>
                            </div>
                        )}
                        {openEditDrawer && (
                            <div className={`drawer-overlay ${closingDrawer ? "closing" : ""}`}
                                 onClick={() => closeDrawer()}>
                                <div className={`drawer ${closingDrawer ? "closing" : ""}`}
                                     onClick={(e) => e.stopPropagation()}>
                                    <h2>Modifier l'utilisateur</h2>

                                    <label>Nom</label>
                                    <input
                                        type="text"
                                        value={editUser?.name || ""}
                                        onChange={(e) => setEditUser({...editUser, name: e.target.value})}
                                    />

                                    <label>Email</label>
                                    <input
                                        type="email"
                                        value={editUser?.email || ""}
                                        onChange={(e) => setEditUser({...editUser, email: e.target.value})}
                                    />

                                    <label>Rôle</label>
                                    <select
                                        value={editUser?.role || "Utilisateur"}
                                        onChange={(e) => setEditUser({...editUser, role: e.target.value})}
                                    >
                                        <option>Utilisateur</option>
                                        <option>Moderateur</option>
                                        <option>Admin</option>
                                    </select>

                                    <label>Statut</label>
                                    <select
                                        value={editUser?.status || "Actif"}
                                        onChange={(e) => setEditUser({...editUser, status: e.target.value})}
                                    >
                                        <option>Actif</option>
                                        <option>Suspendu</option>
                                    </select>

                                    <button className="save-user-btn" onClick={updateUser}>
                                        Enregistrer les modifications
                                    </button>
                                </div>
                            </div>
                        )}
                        {deleteConfirm && (
                            <div className="confirm-overlay" onClick={closeConfirm}>
                                <div
                                    className={`confirm-box ${closingConfirm ? "closing" : ""}`}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <h3>Supprimer cet utilisateur ?</h3>
                                    <p>Cette action est irréversible.</p>

                                    <div className="confirm-actions">
                                        <button className="cancel-btn" onClick={closeConfirm}>
                                            Annuler
                                        </button>
                                        <button
                                            className="delete-btn2"
                                            onClick={async () => {
                                                await deleteUser();   // ta fonction existante
                                                closeConfirm();
                                            }}
                                        >
                                            Supprimer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            {successMessage && (
                <div className="toast-success">
                    {successMessage}
                    <div className="toast-progress" style={{width: `${toastProgress}%`}}></div>
                </div>
            )}
            {errorMessage && (
                <div className="toast-error">
                    {errorMessage}
                    <div className="toast-progress" style={{width: `${toastProgress}%`}}></div>
                </div>
            )}

        </div>
    );
}